import {borderRadiusPrimitive} from '../../styles/primitives/borderRadiusPrimitive';
import {spacingPrimitive} from '../../styles/primitives/spacingPrimitive';
import {themeConstants} from '../themeConstants';
import {ThemeTypesEnum, UserTheme} from '../themeTypes';
import {lightColors} from './lightColors';
import {lightSemanticStyles} from './lightSemanticStyles';

export const lightTheme: UserTheme = {
  ...lightSemanticStyles,
  ...lightColors,
  constants: themeConstants,
  spacing: spacingPrimitive,
  borderRadius: borderRadiusPrimitive,
  type: ThemeTypesEnum.LIGHT,
  hasInboxRedesign: false,
  hasDropdownRedesign: false,
  hasP0AppSwitcher: false,
};
